import { MEMPOOL_API_URL, MEMPOOL_API_URL_TESTNET } from '../../constants';

export const getMempoolApiUrl = (address: string) =>
  address.startsWith('t') ? MEMPOOL_API_URL_TESTNET : MEMPOOL_API_URL;
